/**
 * Network delay simulation for mock responses
 */

/**
 * Simulate network delay with optional variance
 */
export async function simulateDelay(baseDelay: number, variance = 0.3): Promise<void> {
  if (baseDelay <= 0) return;
  
  // Add random variance to make it feel more realistic
  const minDelay = baseDelay * (1 - variance);
  const maxDelay = baseDelay * (1 + variance);
  const actualDelay = Math.random() * (maxDelay - minDelay) + minDelay;
  
  return new Promise(resolve => {
    setTimeout(resolve, actualDelay);
  });
}

/**
 * Simulate different types of network conditions
 */
export const NetworkConditions = {
  fast: { delay: 50, variance: 0.2 },      // Fast connection
  normal: { delay: 200, variance: 0.3 },   // Normal connection  
  slow: { delay: 800, variance: 0.5 },     // Slow connection
  unreliable: { delay: 300, variance: 1.0 } // Unreliable connection
} as const;

/**
 * Simulate network delay based on condition
 */
export async function simulateNetworkCondition(
  condition: keyof typeof NetworkConditions
): Promise<void> {
  const { delay, variance } = NetworkConditions[condition];
  return simulateDelay(delay, variance);
}